import React from "react";
import "./knowHow.css";
import { AiOutlineStock } from "react-icons/ai";
import { SiSonarsource } from "react-icons/si";
import { FaHandsHelping } from "react-icons/fa";
import { GiReceiveMoney } from "react-icons/gi";
import { VscSymbolStructure } from "react-icons/vsc";
import { MdWebAsset } from "react-icons/md";
import { FaAssistiveListeningSystems } from "react-icons/fa";
import { useState } from "react";
const KnowHow = (props) => {
  const t = props.language;
  const arrayText = [
    "kh_1_text",
    "kh_2_text",
    "kh_3_text",
    "kh_4_text",
    "kh_5_text",
  ];
  const arrayTitle = ["kh_1", "kh_2", "kh_3", "kh_4", "kh_5"];
  const [indexClicked, setIndexClicked] = useState();
  return (
    <div className="main__know" id="know-how">
      <div className="partner__div tt">
        <div className="text__partner">
          {t("know_how")}
          <span className="line__partner"></span>
        </div>
        <div className="team__desc--wrap">
          <p className="team__desc">{t("know_how_text")}</p>
        </div>
      </div>

      <div className="main__kn">
        <div className="main__circle">
          <div className="fake__circle"></div>
          <div className="small__circle">
            {typeof indexClicked === "number" ? (
              <h4>{t(`${arrayTitle[indexClicked]}`)}</h4>
            ) : (
              <h4>{t(`${arrayTitle[0]}`)}</h4>
            )}

            {typeof indexClicked === "number" ? (
              <p>{t(`${arrayText[indexClicked]}`)}</p>
            ) : (
              <p>{t(`${arrayText[0]}`)}</p>
            )}
          </div>
        </div>
        <div className="div1 little__circle">
          <AiOutlineStock
            className="logo__circle"
            onClick={() => {
              setIndexClicked(0);
            }}
          />
          <span>{t(`${arrayTitle[0]}`)}</span>
        </div>
        <div className="div2 little__circle">
          <FaAssistiveListeningSystems
            className="logo__circle"
            onClick={() => {
              setIndexClicked(1);
            }}
          />
          <span>{t(`${arrayTitle[1]}`)}</span>
        </div>
        <div className="div3 little__circle">
          <VscSymbolStructure
            className="logo__circle"
            onClick={() => {
              setIndexClicked(2);
            }}
          />
          <span>{t(`${arrayTitle[2]}`)}</span>
        </div>
        <div className="div4 little__circle">
          <FaHandsHelping
            className="logo__circle"
            onClick={() => {
              setIndexClicked(3);
            }}
          />
          <span>{t(`${arrayTitle[3]}`)}</span>
        </div>
        <div className="div5 little__circle">
          <SiSonarsource
            className="logo__circle"
            onClick={() => {
              setIndexClicked(4);
            }}
          />
          <span>{t(`${arrayTitle[4]}`)}</span>
        </div>
        {/* <div className="div6 little__circle">
          <AiOutlineStock className="logo__circle" />
        </div>
        <div className="div7 little__circle">
          <SiSonarsource className="logo__circle" />
        </div> */}
      </div>
    </div>
  );
};

export default KnowHow;
